export default __webpack_public_path__ + "static/scratch-container-rectangle-2-7c5c2f85d09bec1cb7add6d848ef88e2.svg";